import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Dropdown, Form, Icon, Menu, message, Row, Tag, Modal, Tabs, Card } from 'antd';
import SupplierInformation from './components/SupplierInformation';
import ProductInformation from './components/ProductInformation';
import RefundInformation from './components/RefundInformation';
import * as CommonService from '../../../services/CommonService';
import { PURCHASE_ORDER, TEMPLATE } from '../../../services/endpoint';
import { useHistory, useParams } from 'react-router-dom';
import { PURCHASE_ORDER_STATUS } from '../../../utils/const';
import { dateToString } from '../../../utils';

const { confirm } = Modal;

const { TabPane } = Tabs;

const PurchaseOrderDetail = () => {

	const { id } = useParams();

	const history = useHistory();

	const [purchaseDetail, setPurchaseDetail] = React.useState({});
	const [reload, setReload] = React.useState(0);

	const [currentTab, setCurrentTab] = useState('1');

	const init = () => {
		window.setLoading(true);
		CommonService.findById(PURCHASE_ORDER, id).then(res => {
			if (res?.status === 200) {
				setPurchaseDetail(res.data || {});
			}
		}).catch(err => {
			message.error(err?.data?.message || 'Có lỗi xảy ra');
		}).finally(() => window.setLoading(false));
	}

	useEffect(() => {
		init();
	}, []);

	useEffect(() => {
		if (reload !== 0) {
			init();
		}
	}, [reload]);

	const renderStatus = (status) => {
		const currStatus = PURCHASE_ORDER_STATUS.find(el => el.value == status);
		return currStatus &&
			<Tag style={{ width: '100px', textAlign: 'center', marginRight: 0 }}
					 color={currStatus.color}>{currStatus.name}</Tag>;
	};

	const handleFinish = () => {
		confirm({
			icon: 'warning',
			width: '510px',
			title: 'Bạn chắc chắn muốn kết thúc đơn nhập hàng không?',
			content: 'Thao tác này sẽ kết thúc đơn nhập hàng của bạn. Bạn không thể nhập hàng hay xác nhận thanh toán từ đơn đã kết thúc được nữa. Bạn muốn tiếp tục thao tác kết thúc đơn?',
			onOk() {
				window.setLoading(true);
				CommonService.post(`${PURCHASE_ORDER}/${id}/end`).then(res => {
					if (res.status === 200) {
						setPurchaseDetail({ ...purchaseDetail, status: 3 });
						message.success('Kết thúc thành công');
					}
				}).catch(err => {
					message.error(err?.data?.message);
				}).finally(() => window.setLoading(false));
			},
			onCancel() {
				console.log('Cancel');
			},
			okText: 'Kết thúc'
		});
	};

	const handleClickActions = key => {
		switch (key.key) {
			case 'finish':
				handleFinish();
				break;
			default:
				break;
		}
	};

	const actions = (
		<Menu onClick={handleClickActions}>
			<Menu.Item key="finish" disabled={[2, 3].includes(purchaseDetail.status)}>Kết thúc</Menu.Item>
			<Menu.Item key="2" disabled>In mã vạch</Menu.Item>
			{/*<Menu.Item key="3">3rd item</Menu.Item>*/}
		</Menu>
	);
	const handlePrint = async () => {
		try {
			window.setLoading(true);
			const res = await CommonService.get(`${TEMPLATE}/purchase-order/${id}`, {});
			let data = res?.data.replace('<title>', '');
			data = data.replace('</title>', '');
			data = data.replace('Title', '');

			const iframe = document.createElement('iframe');
			iframe.style.position = 'fixed';
			iframe.style.right = '0';
			iframe.style.bottom = '0';
			iframe.style.width = '0';
			iframe.style.height = '0';
			iframe.style.border = '0';
			document.body.appendChild(iframe);

			const iframeDoc = iframe.contentWindow || iframe.contentDocument;
			iframeDoc.document.open();
			iframeDoc.document.write(data);
			iframeDoc.document.close();

			iframe.onload = () => {
				iframe.contentWindow.focus();
				iframe.contentWindow.print();

				setTimeout(() => {
					document.body.removeChild(iframe);
				}, 1000);
			};
		} catch (e) {
			message.error('Có lỗi xảy ra, vui lòng thử lại sau');
			console.log(e);
		} finally {
			window.setLoading(false);
		}
	};


	return (
		<Fragment>
			<Form layout={'vertical'}>
				<Row>
					<Col span={20}><p>
						Mã đơn hàng: <b>{purchaseDetail.code}</b> <span
						style={{ color: '#b9b0b0' }}>{dateToString(purchaseDetail.createdDate)}</span>
					</p>
					</Col>
					<Col span={4} style={{ textAlign: 'right' }}>
						<p>
							{renderStatus(purchaseDetail.status)}
						</p>
					</Col>
					<div style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
						<div style={{ marginRight: 10 }}>
							<Button onClick={handlePrint}>
								<Icon type="printer" style={{ fontSize: 25 }} />
							</Button>
						</div>
						<div style={{ width: '49%' }}><Dropdown overlay={actions}>
							<Button type="primary" style={{ marginRight: 10 }}>
								Thao tác <Icon type="down" />
							</Button>
						</Dropdown></div>
						<div style={{ width: '51%', textAlign: 'right' }}><Button type="primary"
																																			onClick={() => history.push(`/refund/create?id=${id}`)}>
							<Icon type="plus" /> Tạo đơn hoàn trả
						</Button></div>
					</div>
					<Col>
						<SupplierInformation purchaseDetail={purchaseDetail}
																 setPurchaseDetail={setPurchaseDetail}
																 setReload={setReload}
						/>
					</Col>
					<Col>
						<Card className={'mt-20'}>
							<Tabs defaultActiveKey={currentTab} onChange={t => setCurrentTab(t)}>
								<TabPane tab="Thông tin sản phẩm" key="1">
									<ProductInformation
										purchaseDetail={purchaseDetail}
										setPurchaseDetail={setPurchaseDetail}
									/>
								</TabPane>
								<TabPane tab="Thông tin hoàn trả" key="2">
									<RefundInformation purchaseDetail={purchaseDetail} />
								</TabPane>
							</Tabs>
						</Card>
					</Col>
				</Row>
				<Col style={{ textAlign: 'right', marginTop: 10 }}>
					<Button style={{ marginRight: '5px' }} onClick={() => history.push('/purchase-order')}>Thoát</Button>
				</Col>
			</Form>
		</Fragment>
	);
};
export default Form.create({ name: 'PurchaseOrderDetail' })(PurchaseOrderDetail);
